import { WalletLedgerEntry, WalletTopup } from '../../services/wallet-service'

export const SWIFT_COPY_MISSING_REASON = 'No swift copy'
export const SWIFT_COPY_ATTACHED_REASON = 'Swift copy attached'
export const TOPUP_AWAITING_CONFIRMATION_REASON = 'Awaiting confirmation'
export const WITHDRAWAL_AWAITING_TRANSFER_REASON = 'Awaiting transfer initiation'

/** Display labels for income credit ledger types (wallet transaction column). */
export const WALLET_INCOME_LEDGER_LABELS: Record<string, string> = {
  INTEREST_CREDIT: 'Interest Payout',
  DIVIDEND_CREDIT: 'Dividend Payout',
  /** Admin-recorded manual share sale credited to the wallet. */
  MANUAL_SALE_CREDIT: 'Share Sale',
}

export const topupHasProof = (topup: WalletTopup) => {
  const meta = topup.metadata || {}
  const paymentCopy = meta.paymentCopy
  const transactionNumber = meta.transactionNumber
  return (
    (typeof paymentCopy === 'string' && paymentCopy.trim() !== '') ||
    (typeof transactionNumber === 'string' && transactionNumber.trim() !== '')
  )
}

export const isPendingLedgerType = (type: string) =>
  type === 'TOPUP_PENDING' || type === 'WITHDRAW_PENDING'

export const pendingTopupReason = (topup: WalletTopup): string =>
  topupHasProof(topup) ? TOPUP_AWAITING_CONFIRMATION_REASON : SWIFT_COPY_MISSING_REASON

/** Reason for pending / rejected rows; empty when no client-facing reason. */
export const ledgerReasonForRow = (row: WalletLedgerEntry, openTopups: WalletTopup[]): string => {
  if (row.type === 'WITHDRAW_PENDING') {
    return WITHDRAWAL_AWAITING_TRANSFER_REASON
  }
  if (row.type === 'TOPUP_REJECTED') {
    if (row.metadata?.cancelledByInvestor === true) return ''
    const reason = row.metadata?.rejectionReason
    return typeof reason === 'string' ? reason : ''
  }
  if (row.type !== 'TOPUP_PENDING') return ''

  const topup = openTopups.find((item) => String(item.id) === String(row.reference_id))
  if (topup && topupHasProof(topup)) {
    return TOPUP_AWAITING_CONFIRMATION_REASON
  }
  // Missing SWIFT, or pending without linked open top-up detail.
  return SWIFT_COPY_MISSING_REASON
}
